module.exports = __webpack_public_path__ + "img/recenter-ic.c2f9ca76.svg";